/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";

import { withAuthenticationRequired } from "./Auth0";

export default withAuthenticationRequired(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  {
    loginOptions: {
      appState: {
        returnTo: window.location.pathname,
      },
    },
  }
);
